import React from 'react';
import SwipeableViews from 'react-swipeable-views';

import Box from '@material-ui/core/Box';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import ColorButton from './ColorButton';

const TabPanel = (props) => {
  const { children, value, index, ...other } = props;

  return (
    <div
      role='tabpanel'
      hidden={value !== index}
      id={`full-width-tabpanel-${index}`}
      aria-labelledby={`full-width-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={0}>
          {children}
        </Box>
      )}
    </div>
  );
}

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  padding: {
    padding: theme.spacing(3),
  },
}));

export default function ButtonTabs({ tabs, activeTab, onTabChange, children }) {
  const classes = useStyles();
  const theme = useTheme();

  return (
    <div className={classes.root}>
      <div className={classes.demo1}>
        {tabs?.map((tab) => (
          <ColorButton
            key={tab.key}
            className={`button-tabs__button button-tabs__button--${activeTab === tab.key ? 'active' : 'inactive'} m-r-lg`}
            text={tab.label}
            onClick={() => onTabChange(tab.key)}
            color={activeTab === tab.key ? 'blue' : 'grey'}
            height={30}
          />
        ))}
      </div>
      <SwipeableViews
        axis={theme.direction === 'rtl' ? 'x-reverse' : 'x'}
        index={activeTab}
        onChangeIndex={onTabChange}
      >
        { tabs.map((tab, index) => (
          <TabPanel
            key={`tab-${index}`}
            value={activeTab}
            index={index}
            dir={theme.direction}
          >
            { children }
          </TabPanel>
        ))}
      </SwipeableViews>
    </div>
  );
}
